import * as v from 'valibot';
import { windowWebFeaturesSchema } from './windowWebFeatures';

const webfeaturesSchema = windowWebFeaturesSchema;
const realmConfigSchema = v.optional(v.unknown());

const baseUrlsSchema = v.object({
  cpweb: v.optional(v.string()),
  cbweb: v.optional(v.string()),
  pdweb: v.optional(v.string()),
  apiweb: v.optional(v.string()),
  upweb: v.optional(v.string()),
  login: v.optional(v.string()),
  cdn: v.optional(v.string()),
  aleweb: v.optional(v.string()),
  boweb: v.optional(v.string()),
  tpweb: v.optional(v.string()),
});

const apiUrlsSchema = v.object({
  cpweb: v.optional(v.string()),
  cbweb: v.optional(v.string()),
  apiweb: v.optional(v.string()),
  ccapi: v.optional(v.string()),
  reportingApi: v.optional(v.string()),
  aleweb: v.optional(v.string()),
  automations: v.optional(v.string()),
});

const configSchema = v.object({
  langBundle: v.optional(v.string()),
  capabilities: v.optional(
    v.object({
      academyLogout: v.optional(v.boolean()),
      accountSettings: v.optional(v.boolean()),
      realmOwner: v.optional(v.string()),
      deeplinks: v.optional(v.string()),
    }),
  ),
  client: v.optional(v.string()),
  webpackLoadPath: v.optional(v.string()),
  appContextPath: v.optional(v.string()),
  locale: v.optional(v.string()),
  baseUrls: baseUrlsSchema,
  apiUrls: apiUrlsSchema,
  features: v.optional(
    v.object({
      participations: v.optional(
        v.object({
          name: v.optional(v.string()),
          value: v.optional(v.number()),
          upgradable: v.optional(v.boolean()),
        }),
      ),
      administrators: v.optional(
        v.object({
          name: v.optional(v.string()),
          value: v.optional(v.number()),
          upgradable: v.optional(v.boolean()),
        }),
      ),
    }),
  ),
  genericBrandingId: v.optional(v.number()),
  webfeatures: v.optional(webfeaturesSchema),
  loggedIn: v.optional(v.boolean()),
  rtlsupport: v.optional(v.boolean()),
  pageTitle: v.optional(v.nullable(v.string())),
  deviceType: v.optional(v.nullable(v.string())),
  mobileDevMode: v.optional(v.boolean()),
  realmId: v.optional(v.string()),
  tusChunkSize: v.optional(v.number()),
  aleTheme: v.optional(v.string()),
  realmConfig: realmConfigSchema,
});

const capabilitiesSchema = v.optional(v.record(v.string(), v.union([v.literal('on'),v.literal('off'),v.literal('upgradeable')])));

const extSchema = v.optional(
  v.object({
    clientPortal: v.optional(
      v.object({
        currentOrgId: v.optional(v.number()),
        permissions: v.optional(v.array(v.string())),
        trialEnd: v.optional(v.nullable(v.unknown())),
        capabilities: capabilitiesSchema
      }),
    ),
    backOfficePortal: v.optional(v.object({
      permissions: v.optional(v.array(v.string())),
      capabilities: capabilitiesSchema
    })),
    productDirectoryPortal: v.optional(v.object({
      permissions: v.optional(v.array(v.string())),
      capabilities: capabilitiesSchema
    })),
    trainerPortal: v.optional(v.object({
      permissions: v.optional(v.array(v.string())),
      capabilities: capabilitiesSchema
    })),
    header: v.optional(
      v.object({
        portalPicker: v.object({
          orgs: v.array(
            v.object({
              clientno: v.optional(v.nullable(v.string())),
              id: v.number(),
              text: v.string(),
              viewLink: v.string(),
              favorite: v.boolean(),
            }),
          ),
        }),
      }),
    ),
    microfrontend: v.optional(
      v.object({
        basename: v.string(),
        participationId: v.optional(v.string()),
        projectId: v.optional(v.number()),
        langBundle: v.optional(v.string()),
        languageLocale: v.optional(v.string()),
      }),
    ),
  }),
);

export const windowAppStateSchema = v.object({
  config: configSchema,
  ext: extSchema,
});

export type WindowAppState = v.Output<typeof windowAppStateSchema>;
